var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-20 w-full h-full items-center pb-0 outline-none box-border flex flex-col justify-center absolute inset-0"},[_c('instruction',{attrs:{"instruction":_vm.instruction},on:{"action":_vm.handleActionButton}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }